import React, { Component } from "react";
import "./Dialog.less";

const DIALOG_BGIMG = {
  'default': 'url(https://cdn.jisuapp.cn/static/webapp/images/chatgpt/diabg.png)',
  'delete' : 'url(https://cdn.jisuapp.cn/static/webapp/images/chatgpt/diabg_del.png)'
}
class Dialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      title: "是否确定",
      content: "",
      status: 'default', // OR 'delete'
      cancelText: "取消",
      confirmText: "确定",
      cancel: function () {},
      confirm: function () {},
    };
  }
  componentWillUnmount() {
    this.setState = () => {
      return;
    };
  }

  close = () => {
    this.setState({
      show: false,
    });
  };

  showModal = (options) => {
    options = options || {};
    this.setState({
      show: true,
      title: typeof options.title == 'string' && options.title || "是否确定",
      content: typeof options.content == 'string' && options.content || "",
      status: typeof options.status == 'string' && (options.status == 'default' || options.status == 'delete') && options.status || 'default',
      cancelText: typeof options.cancelText == 'string' && options.cancelText || "取消",
      confirmText: typeof options.confirmText == 'string' && options.confirmText || "确认",
      cancel: typeof options.cancel == 'function' && options.cancel || function () {},
      confirm: typeof options.confirm == 'function' && options.confirm || function () {},
    })
  }

  //取消
  cancel = () => {
    this.state.cancel();
    this.close();
  };
  //确认
  confirm = () => {
    this.state.confirm();
    this.close();
  };

  render() {
    let { title, content, status, cancelText, confirmText } = this.state;
    return (
      <div>
      { this.state.show &&
        <div className="dialog">
          <div className="mask" onClick={this.cancel}></div>
          <div className="dia_box" style={{backgroundImage: DIALOG_BGIMG[status]}}>
            <div className="title">{title}</div>
            <div className="content" title={content}>{content}</div>
            <div className="controls">
              <div className="cancelbtn" onClick={this.cancel}>{cancelText}</div>
              <div className="confirmbtn" onClick={this.confirm}>{confirmText}</div>
            </div>
          </div>
        </div>
      }
      </div>
    );
  }
}


let div = document.createElement('div');
document.body.appendChild(div);
let DialogAlert = ReactDOM.render(<Dialog /> ,div);
export default DialogAlert; 


// WEBPACK FOOTER //
// ./src/chatgpt-page/dialog/Dialog.jsx